<template>
  <Starfield>
    <iRow align="center" vertical-align="middle" height="fill">
      <iColumn width="fill" :max-width="480" align="center">
        <iCard width="fill" data-test="oauth-consent">
          <template #body>
            <iColumn gap="large" width="fill">
              <iColumn gap="extraSmall" width="fill">
                <iHeading font-size="extraLarge">
                  Allow {{ clientName }} to use your account?
                </iHeading>
                <iRow v-if="unverified" gap="extraSmall" vertical-align="middle">
                  <iIcon icon="exclamation-triangle" variant="warning" size="small" />
                  <iText variant="error" font-size="small" data-test="oauth-consent-unverified">
                    Unverified app: it registered itself and Inspiration has not reviewed it.
                  </iText>
                </iRow>
              </iColumn>
              <iText variant="subtle">
                After you allow it, {{ clientName }} can act as you in q3po through its MCP server, with your own permissions.
              </iText>
              <iColumn gap="small" width="fill">
                <iText font-weight="dark">
                  It is asking to:
                </iText>
                <iRow
                  v-for="scope in scopes"
                  :key="scope"
                  gap="small"
                  vertical-align="middle"
                >
                  <iIcon icon="check" size="small" />
                  <iText :data-test="`oauth-consent-scope-${scope}`">
                    {{ scopeLabel(scope) }}
                  </iText>
                </iRow>
              </iColumn>
              <iText variant="subtle" font-size="small">
                It will receive access at {{ redirectHost }}. Only allow apps you trust.
              </iText>
              <iRow gap="standard" width="fill" align="right">
                <iButton
                  variant="secondary"
                  data-test="oauth-consent-deny"
                  :disabled="submitting"
                  @click="decide('deny')"
                >
                  Deny
                </iButton>
                <iButton
                  variant="primary"
                  data-test="oauth-consent-allow"
                  :is-loading="submitting"
                  @click="decide('allow')"
                >
                  Allow
                </iButton>
              </iRow>
            </iColumn>
          </template>
        </iCard>
      </iColumn>
    </iRow>
  </Starfield>
</template>

<script>
import Starfield from "@/components/Starfield";
import { postConsentDecision, scopeLabel } from "@/helpers/oauth-consent.mjs";

export default {
  name: "OAuthConsent",
  components: {
    Starfield,
  },
  props: {
    clientName: { type: String, required: true },
    clientId: { type: String, required: true },
    unverified: { type: Boolean, required: true },
    redirectHost: { type: String, required: true },
    scopes: { type: Array, required: true },
    formAction: { type: String, required: true },
    formFields: { type: Object, required: true },
  },
  data() {
    return { submitting: false };
  },
  methods: {
    scopeLabel,
    decide(decision) {
      this.submitting = true;
      postConsentDecision(document, this.formAction, this.formFields, decision);
    },
  },
};
</script>
